const ad = {
    title: {
        es: "Convocatoria Asamblea General Ordinaria De Accionistas",
        en: "Ordinary General Shareholders' meeting Summon"
    },
    content: {
        es: `Se convoca a los señores accionistas de INVERSIONES CRECEPYMES C.A, para la Asamblea General
        Ordinaria de Accionistas a celebrarse el Edificio Galería Pantín, Planta Baja, local 3, Avenida Libertador
        cruce con Calle Pantín, Urbanización Eduardo Leal, Chacao, Caracas, el día 26 del mes marzo de 2021 a las
        10 a.m., la cual tendrá por objeto los siguientes puntos:
        
        PRIMERO: Considerar y resolver sobre el Informe que presenta la Junta Directiva sobre las actividades
        realizadas durante el ejercicio concluido el 31 de diciembre de 2020.

        SEGUNDO: Considerar y resolver acerca de la aprobación o improbación de los Estados Financieros
        correspondientes al ejercicio económico concluido el 31 de diciembre de 2020, con vistas al Informe de
        los Comisarios y de los auditores externos.

        NOTA. (1) Los accionistas podrán hacerse representar en la Asamblea mediante poder que puede
        otorgarse por carta dirigida a la Junta Directiva. La información relacionada con la presente Convocatoria
        está a disposición de los accionistas en la página web: www.crecepymes.com.
        (2) Con ocasión a la pandemia denominada Coronavirus (COVID-19) y en estricto cumplimiento de la
        Resolución N0. 090, de fecha 1˚ de junio de 2020 del Ministerio del Poder Popular para la Salud, mediante
        la cual se establece la normativa sanitaria de responsabilidad social ante la referida pandemia, se
        requerirá en la asamblea el uso obligatorio de mascarilla, distanciamiento social mínimo de 1,5 metros
        entre los asistentes y se aplicará antibacterial al ingreso de las instalaciones.
        `,
        en: `The shareholders of INVERSIONES CRECEPYMES C.A are summoned for the General Assembly
        Ordinary Shareholders to be held in the Pantín Gallery Building, Ground Floor, local 3, Avenida Libertador
        crossing with Calle Pantín, Urbanización Eduardo Leal, Chacao, Caracas, on March 26, 2021 at
        10 a.m., which will have as its object the following points:
        FIRST: Consider and resolve on the Report presented by the Board of Directors on the activities
        made during the year ended December 31, 2020.
        SECOND: Consider and resolve about the approval or disapproval of the Financial Statements
        corresponding to the fiscal year ended on December 31, 2020, with a view to the Report on
        the Commissioners and the external auditors.
        NOTE. (1) Shareholders may be represented at the Assembly by proxy that may
        be granted by letter addressed to the Board of Directors. Information related to this Call
        It is available to shareholders on the website: www.crecepymes.com.
        (2) On the occasion of the pandemic called Coronavirus (COVID-19) and in strict compliance with the
        Resolution N0. 090, dated June 1, 2020 from the Ministry of Popular Power for Health, through
        which establishes the health regulations of social responsibility in the face of the aforementioned pandemic,
        will require the mandatory use of a mask in the assembly, minimum social distancing of 1.5 meters
        among the attendees and antibacterial will be applied at the entrance of the facilities.`
    },
    date: "08/03/2021"
}

export default ad
